import request from './request';

export function createBlog(blog){
  return request('post', `/apiv2/blogs/create`, blog);
}

export function updateBlog(id, blog){
  return request('post', `/apiv2/blogs/${id}/update`, blog);
}

export function deleteBlog(id){
  return request('post', `/apiv2/blogs/${id}/delete`);
}

export function blogsRelated(id){
  return request('get', `/apiv2/blogs/${id}/blogs_related`, {});
}